module.exports = __webpack_public_path__ + "assets/img/6625ccf0d64333acefd98117b9b283af.png";